import { useQuery } from "@tanstack/react-query";
import type { PassType } from "../models/PassType";
import {
	type GetPassTypesParams,
	getPassTypes,
} from "../repositories/PassTypesRepository";

// ============================================
// Query Keys
// ============================================

export const PASS_TYPES_QUERY_KEYS = {
	all: ["passTypes"] as const,
	list: (params?: GetPassTypesParams) => ["passTypes", "list", params] as const,
	detail: (id: number | null) => ["passTypes", "detail", id] as const,
};

// ============================================
// usePassTypes Hook
// ============================================

interface UsePassTypesResult {
	passTypes: PassType[];
	isLoading: boolean;
	error: Error | null;
	refetch: () => void;
}

export const usePassTypes = (): UsePassTypesResult => {
	const params: GetPassTypesParams = {
		onlyActives: false,
	};

	const query = useQuery({
		queryKey: PASS_TYPES_QUERY_KEYS.list(params),
		queryFn: () => getPassTypes(params),
	});

	return {
		passTypes: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error as Error | null,
		refetch: query.refetch,
	};
};
